export default __webpack_public_path__ + "static/media/Upload.47ac17cf.svg";